var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    fill: "#6e6e6e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.5,0h-4.5c-1.103,0-2,.897-2,2v4c0,1.103.897,2,2,2h7c1.103,0,2-.897,2-2v-1.5c0-2.481-2.019-4.5-4.5-4.5Zm-4.5,6V2h4.5c1.379,0,2.5,1.122,2.5,2.5v1.5s-7,0-7,0Zm7,4h-14v-4c0-1.103-.897-2-2-2h-1.5C2.019,4,0,6.019,0,8.5v11c0,2.481,2.019,4.5,4.5,4.5h15c2.481,0,4.5-2.019,4.5-4.5v-7.5c0-1.103-.897-2-2-2Zm0,6h-9v-4h9v4Zm-6,2v4h-8v-4h8ZM2,8.5c0-1.378,1.121-2.5,2.5-2.5h1.5v4H2v-1.5Zm9,3.5v4H2v-4h9Zm-9,7.5v-1.5h4v4h-1.5c-1.379,0-2.5-1.122-2.5-2.5Zm17.5,2.5h-1.5v-4h4v1.5c0,1.378-1.121,2.5-2.5,2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralSettingIcon);
export default __webpack_public_path__ + "static/media/generalSettingIcon.d6a303925a346363c85921129b813b4e.svg";
export { ForwardRef as ReactComponent };